import styled from 'styled-components'

export const FeedbackSelection = styled.ul`
  margin-bottom: 2.5rem;
`

export const FeedbackActionButtonsWrapper = styled.div`
  margin-top: 2.5rem;
`
